export default __webpack_public_path__ + "static/media/logo.494f1213.svg";